import styles from './index.module.scss'
import { Table, message, Drawer, Input, Popover, Select, Upload, } from 'antd'
import { useState, useCallback, useMemo, useEffect, useRef, useContext } from "react"
import SelectTryonPose from '../components/SelectTryonPose'
import GoBack from "../components/GoBack";
import { useNavigate } from "react-router-dom";
import { EditOutlined, PlusOutlined, LoadingOutlined, MinusOutlined } from '@ant-design/icons';
import PSAIModal from '@PSAIComponents/PSAIModal';
import Iconfont from '@utils/Iconfont';
import ServiceSampleModal from '@view/compoents/ServiceSampleModal'
import Utils from '@utils/utils';
import FooterBar from './FooterBar'
import UploadBox from '../components/UploadBox'
import API from "@api/api";
import { UPLOAD_SOURCE, BATCH_IMAGES_TYPE } from "@utils/CONST"
import TableUploadView from './component/TableUploadView.jsx'
import { BatchImagesContext } from '../BatchImagesContext.js'
import InputNumber from './component/InputNumber.jsx'
import DragAndSort from './component/DragAndSort/DragAndSort.jsx'

const TableWrap = (props) => {
    const { setFileList } = useContext(BatchImagesContext)
    const { projectType, dataSource, setDataSource, projectId, uploading, projectName, total, editSkuId, editTaskId, isEdit, isProCenter, projectSerial } = props
    const navigate = useNavigate()
    const [drawOpen, setDrawOpen] = useState(false)
    const [editNameVisible, setEditNameVisible] = useState(false)
    const [nickName, setNickName] = useState('')
    const [loading, setLoading] = useState(false)
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [selectedRows, setSelectedRows] = useState([])
    const [uploadOpen, setUploadOpen] = useState(false)
    const [commoditySortOpen, setCommoditySortOpen] = useState(false)
    const [showSelectionColumn, setShowSelectionColumn] = useState(false)
    const materialRef = useRef()
    const footerBarRef = useRef()
    const [editNameTitle, setEditNameTitle] = useState('修改商品名')
    const [uploadType, setUploadType] = useState(BATCH_IMAGES_TYPE.TRYON_BATCH) // AI试衣存在选模特和姿势两种情况
    const [uploadCount, setUploadCount] = useState(10) // 选择资源数量
    const [drawSelectedValue, setDrawSelectedValue] = useState([]) // 已选的素材

    const skuColumns = useMemo(() => {
        const columns = [{
            title: '商品名称',
            key: '1',
            width: 250,
            render: (text, record) => {
                return <div className={styles.tableCellName}>
                    <p>ID:{record.skuSerial}</p>
                    <p>{record.skuName} {!isEdit && <EditOutlined style={{ color: '#96A2B1' }} onClick={() => editSkuName(record)} />} </p>
                </div>
            }
        }, {
            title: (
                <div style={{ display: "flex", gap: 8 }}>
                    <span>
                        <span style={{ color: '#FF0000' }}>*</span>
                        {projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ? '商品图' : projectType === BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH ? '主品图' : '模特图'}
                    </span>
                    {
                        <Popover
                            placement="bottomLeft"
                            arrow={false}
                            content={<ServiceSampleModal showValue={projectType} />}
                        >
                            <Iconfont type="icon-QuestionCircleOutlined" className={styles.Icon} />
                        </Popover>
                    }
                </div>
            ),
            key: '2',
            width: 200,
            render: (text, record) => {
                return record?.inputImages?.filter(item => item.mainImage === true)?.length == 1 ?
                    <TableUploadView
                        isEdit={isEdit}
                        url={record?.inputImages?.filter(item => item.mainImage === true)[0]?.url}
                        item={record} type={'mainImg'}
                        width={(projectType === BATCH_IMAGES_TYPE.TRYON_BATCH || projectType === BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH) ? 128 : 96}
                        listSkuByProject={props.listSkuByProject}
                        projectId={projectId}
                        onReupload={(file, fileList, item, type) => beforeUpload(file, fileList, item, type)} /> :
                    <div className={styles.coordinationWrap}>
                        <Upload.Dragger
                            accept='image/jpeg,image/png,image/webp,image/avif'
                            listType="picture-card"
                            showUploadList={false}
                            className={styles.MatchClothesUpload}
                            beforeUpload={(file, fileList) => beforeUpload(file, fileList, record, 'mainImg')}
                            onDrop={(e) => handleDrop(e, 'mainImg')}
                            disabled={loading}
                            multiple={false}
                        >
                            <div className={styles.SelectModelBtnContent}>
                                {loading ? <LoadingOutlined /> : <PlusOutlined />}
                                <p>上传{projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ? '商品图' : '模特图'}</p>
                            </div>
                        </Upload.Dragger>
                    </div>
            }
        }]
        if (projectType === BATCH_IMAGES_TYPE.TRYON_BATCH) {
            columns.push(...[{
                title: (<><span style={{ color: '#FF0000' }}>*</span>服装类型</>),
                key: '3',
                width: 200,
                render: (text, record) => {
                    const clothType = record?.inputImages?.filter(item => item.mainImage === true)[0]?.clothType
                    return (
                        clothType === '' ? <Select
                            suffixIcon={<LoadingOutlined />}
                            style={{ width: 140 }}
                            placeholder='自动识别服装类型'
                            disabled={true}
                        /> : <Select
                            style={{ width: 120 }}
                            disabled={isEdit}
                            onChange={(value) => clothTypeChange(record, value)}
                            placeholder="服装类型"
                            value={clothType}
                            options={[
                                { value: 0, label: '上装' },
                                { value: 1, label: '下装' },
                                { value: 3, label: '连体装' }
                            ]}
                        />
                    )
                }
            }, {
                title: '搭配（非必填）',
                key: '4',
                width: 200,
                render: (text, record) => {
                    const clothType = record?.inputImages?.filter(item => item.mainImage === true)[0]?.clothType
                    return (
                        record?.inputImages?.filter(item => item.mainImage === false)?.length == 1 ?
                            <TableUploadView
                                url={record?.inputImages?.filter(item => item.mainImage === false)[0]?.url}
                                item={record}
                                type={'matchImg'}
                                width={128}
                                listSkuByProject={props.listSkuByProject}
                                projectId={projectId}
                                onReupload={(file, fileList, item, type) => beforeUpload(file, fileList, item, type)} /> :
                            <div className={styles.coordinationWrap}>
                                <Upload.Dragger
                                    accept='image/jpeg,image/png,image/webp,image/avif'
                                    listType="picture-card"
                                    showUploadList={false}
                                    className={styles.MatchClothesUpload}
                                    beforeUpload={(file, fileList) => beforeUpload(file, fileList, record, 'matchImg')}
                                    onDrop={(e) => handleDrop(e, 'matchImg')}
                                    disabled={(record?.matchLoading && uploading) || clothType === 3}
                                    multiple={false}
                                >
                                    <div className={styles.SelectModelBtnContent}>
                                        {record?.matchLoading ? <LoadingOutlined /> : <PlusOutlined />}
                                        <p>上传搭配图</p>
                                    </div>
                                </Upload.Dragger>
                            </div>
                    )
                }
            }, {
                title: '模特（非必填）',
                key: '5',
                width: 200,
                render: (text, record) => {
                    return (
                        record?.modelList?.length == 0 ?
                            <div className={styles.SelectModelBtn}
                                onClick={() => openReferenceDrawer([], 1, record, BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH)}>
                                <div className={styles.SelectModelBtnContent}>
                                    <PlusOutlined />
                                    <p>选择模特</p>
                                </div>
                            </div> : <div className={`${styles.ImageCell}`} >
                                <img src={Utils.getImgThumbnail(record?.modelList?.[0]?.url)} alt="" />
                                <div className={styles.maskBox}
                                    onClick={() => openReferenceDrawer([...record?.modelList], 1, record, BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH)}>
                                    <p><Iconfont type="icon-rebuildOutlined" /><span>重选</span></p>
                                </div>
                            </div>
                    )
                }
            }, {
                title: (<><span style={{ color: '#FF0000' }}>*</span>{'试衣参考图（1 - 10张）'}</>),
                key: '6',
                render: (text, record) => {
                    return (
                        record?.refList?.length == 0 ? <div
                            className={`${styles.SelectModelBtn} ${record?.error ? styles.SelectModelBtnError : ''}`}
                            style={{ width: 512 }}
                            onClick={() => openReferenceDrawer([], 10, record, BATCH_IMAGES_TYPE.TRYON_BATCH)}>
                            <div className={styles.SelectModelBtnContent}>
                                <PlusOutlined />
                                <p>选择1到10张试衣参考图</p>
                            </div>
                        </div> : <div className={styles.refListBox} style={{ maxWidth: 512 }}>
                            {record?.refList?.slice(0, 5).map((item, index) => (
                                <img key={index} src={Utils.getImgThumbnail(item.url)} alt="" />
                            ))}
                            {
                                record?.refList?.length > 5 && <p className={styles.number}><Iconfont type="icon-copyOutlined" /><span>{record?.refList?.length}</span></p>
                            }
                            <div className={styles.maskBox}
                                onClick={() => openReferenceDrawer([...record?.refList], 10, record, BATCH_IMAGES_TYPE.TRYON_BATCH)}>
                                <p><Iconfont type="icon-pencil" /><span>编辑</span></p>
                            </div>
                        </div>
                    )
                }
            }])
        } else if (projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH) {
            columns.push(...[{
                title: (<><span style={{ color: '#FF0000' }}>*</span>{'模特参考图（1 - 10张）'}</>),
                key: '9',
                render: (text, record) => {
                    return (
                        record?.modelList?.length == 0 ? <div
                            className={`${styles.SelectModelBtn} ${record?.error ? styles.SelectModelBtnError : ''}`}
                            style={{ width: 1032 }}
                            onClick={() => openReferenceDrawer([], 10, record, BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH)}>
                            <div className={styles.SelectModelBtnContent}>
                                <PlusOutlined />
                                <p>选择1到10张模特参考图</p>
                            </div>
                        </div> : <div className={styles.refListBox} style={{ maxWidth: 1032 }}>
                            {record?.modelList?.map((item, index) => (
                                <img key={index} src={Utils.getImgThumbnail(item.url)} alt="" />
                            ))}
                            {
                                record?.modelList?.length > 5 && <p className={styles.number}><Iconfont type="icon-copyOutlined" /><span>{record?.modelList?.length}</span></p>
                            }
                            <div className={styles.maskBox}
                                onClick={() => openReferenceDrawer([...record?.modelList], 10, record, BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH)}>
                                <p><Iconfont type="icon-pencil" /><span>编辑</span></p>
                            </div>
                        </div>
                    )
                }
            }])
        } else if (projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH) {
            columns.push(...[{
                title: (<><span style={{ color: '#FF0000' }}>*</span>{'背景参考图（1 - 10张）'}</>),
                key: '10',
                render: (text, record) => {
                    return (
                        record?.bkgList?.length == 0 ? <div
                            className={`${styles.SelectModelBtn} ${record?.error ? styles.SelectModelBtnError : ''}`}
                            style={{ width: 1032 }}
                            onClick={() => openReferenceDrawer([], 10, record, 'changeBkgBatch')}>
                            <div className={styles.SelectModelBtnContent}>
                                <PlusOutlined />
                                <p>选择1到10张背景参考图</p>
                            </div>
                        </div> : <div className={styles.refListBox} style={{ maxWidth: 1032 }}>
                            {record?.bkgList?.map((item, index) => (
                                <img key={index} src={Utils.getImgThumbnail(item.url)} alt="" />
                            ))}
                            {
                                record?.bkgList?.length > 5 && <p className={styles.number}><Iconfont type="icon-copyOutlined" /><span>{record?.bkgList?.length}</span></p>
                            }
                            <div className={styles.maskBox}
                                onClick={() => openReferenceDrawer([...record?.bkgList], 10, record, 'changeBkgBatch')}>
                                <p><Iconfont type="icon-pencil" /><span>编辑</span></p>
                            </div>
                        </div>
                    )
                }
            }])
        } else if (projectType === BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH) {
            columns.push(...[{
                title: (<><span style={{ color: '#FF0000' }}>*</span>主品展示数量</>),
                key: '7',
                width: 200,
                render: (text, record) => {
                    const currentNum = record.inputImages?.[0]?.num || 1;

                    return <InputNumber
                        currentNum={currentNum}
                        min={1} max={50}
                        minusChange={() => handleNumberChange('minus', record)}
                        addChange={() => handleNumberChange('add', record)}
                        onChange={(value) => handleNumberChange('change', record, value)} />
                }
            }, {
                title: (<>
                    辅品图
                    {
                        <Popover
                            placement="bottomLeft"
                            arrow={false}
                            content={<ServiceSampleModal showValue={projectType} />}
                        >
                            <Iconfont style={{ marginLeft: 8 }} type="icon-QuestionCircleOutlined" className={styles.Icon} />
                        </Popover>
                    }
                </>),
                key: '10',
                render: (text, record) => {
                    return (
                        record?.refList?.length == 0 ? <div
                            className={`${styles.SelectModelBtn} ${record?.error ? styles.SelectModelBtnError : ''}`}
                            style={{ width: 944 }}
                            onClick={() => openReferenceDrawer([], 20, record, BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH)}>
                            <div className={styles.SelectModelBtnContent}>
                                <PlusOutlined />
                                <p>选择1-20张辅品图并设置图片数量</p>
                            </div>
                        </div> : <div className={styles.refListBox} style={{ maxWidth: 944 }}>
                            {record?.refList?.map((item, index) => (
                                <div className={styles.refListBoxImg} key={index}>
                                    <img key={index} src={Utils.getImgThumbnail(item.url)} alt="" />
                                    <p className={styles.refListBoxNumber}>数量 {item.num}</p>
                                </div>
                            ))}
                            <div className={styles.maskBox} onClick={() => openReferenceDrawer([...record?.refList], 20, record, BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH)}>
                                <p><Iconfont type="icon-rebuildOutlined" /><span>重选辅品</span></p>
                            </div>
                        </div>
                    )
                }
            }])
        }
        if (!isEdit && projectType != BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH) {
            columns.push(...[{
                title: '操作',
                key: '8',
                width: 150,
                render: (text, record) => {
                    return <span className={styles.DeleteBtn} onClick={() => handleRemove([record.skuId])}>删除</span>
                }
            }])
        }
        if (projectType === BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH) {
            columns.push(...[{
                title: '操作',
                fixed: 'right',
                key: '8',
                width: 200,
                render: (text, record) => {
                    return <>
                        {
                            !isEdit && <p className={styles.operationWrap}>
                                <span className={styles.DeleteBtn} onClick={() => handleCopySku(record.skuId)}>复制主品</span>
                                <span className={styles.DeleteBtn} onClick={() => handleRemove([record.skuId])}>删除</span>
                            </p>
                        }
                        <p
                            onClick={() => editCommoditySort(record)}
                            className={`${styles.operationWrap} ${record?.refList?.length > 0 ? '' : styles.operationWrapDisabled}`}
                        >编辑辅品数量和顺序</p>
                    </>
                }
            }])
        }

        return columns
    }, [projectType])

    const handleRemove = (skuId) => {
        PSAIModal.confirm({
            title: '请确认删除图片',
            content: <span style={{ color: "#FF3B30" }}>此操作不可撤销，删除后将清空该设置</span>,
            onOk() {
                API.batchRemoveSku({
                    skuIds: [...skuId]
                }).then(res => {
                    if (res?.code === 0) {
                        message.success('删除成功！')
                        props.listSkuByProject()
                        footerBarRef.current?.handleBatchExit()
                    }
                })
            }
        })
    }

    const handleCopySku = (skuId) => {
        API.batchCopySku({
            skuId
        }).then(res => {
            if (res?.code === 0) {
                props.listSkuByProject()
            } else {
                message.error(res?.message)
            }
        })
    }

    // 修改服装类型
    const clothTypeChange = async (record, value) => {
        let updatedInputImages;
        if (value === 3) {
            // 当value === 3时，修改主图的clothType，并删除搭配图项
            updatedInputImages = record.inputImages
                .filter(item => item.mainImage)
                .map(item => ({ ...item, clothType: value }));
        } else {
            // 其他情况下，只修改主图的clothType
            updatedInputImages = record.inputImages.map(item =>
                item.mainImage ? { ...item, clothType: value } : item
            );
        }

        const saveRes = await API.batchSaveSku([{
            ...record,
            inputImages: updatedInputImages,
            projectId
        }])
        if (saveRes?.code === 0) props.listSkuByProject()
    }
    // 修改商品名/项目名
    const recordRef = useRef({})
    const editSkuName = (record) => {
        setEditNameTitle(`修改商品名`)
        setNickName(record.skuName)
        recordRef.current = record
        setEditNameVisible(true)
    }
    const editProjectName = () => {
        setEditNameTitle(`修改项目名`)
        setNickName(projectName)
        setEditNameVisible(true)
    }
    const updateNameOk = async () => {
        if (!nickName) { message.warning('请输入新名称'); return; }
        let saveRes = {}
        if (editNameTitle == '修改商品名') {
            saveRes = await API.batchSaveSku([{
                ...recordRef.current,
                skuName: nickName,
                projectId
            }])
        } else {
            saveRes = await API.batchUpdateProject({
                projectName: nickName,
                projectId
            })
        }
        if (saveRes?.code === 0) {
            setEditNameVisible(false)
            setNickName('')
            recordRef.current = {}
            props.listSkuByProject()
        }
    }

    function removeExtension(filename) {
        // 处理特殊文件名：'.' 和 '..'
        if (filename === '.' || filename === '..') return filename;
        const lastDot = filename.lastIndexOf('.');
        // 无后缀或隐藏文件（如 ".gitignore"）
        if (lastDot === -1 || lastDot === 0) return filename;
        return filename.substring(0, lastDot);
    }
    const uploadDebounce = useCallback(_.debounce(async (file, fileList, type, maxCount = 1) => {
        setLoading(true)
        const _fileList = maxCount == -1 ? fileList : fileList.slice(0, maxCount)
        for (let file of _fileList) {
            // 检查文件类型和宽高比
            let isNromal
            if (projectType === BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH) {
                // 商品堆叠仅支持透明底
                isNromal = await Utils.validateImageFilePNG(file)
            } else {
                isNromal = await Utils.validateImageFile(file)
            }
            if (!isNromal) { props.listSkuByProject(); setSkuMatchLoadingList(prev => prev.filter(id => id !== recordRef.current.skuId)); continue }
            // resize图片
            const resizeRes = await Utils.resizeImageFileMaxByAliyunBy(file, 4096)
            if (!resizeRes || !resizeRes.success) { message.warning(resizeRes?.message); props.listSkuByProject(); setSkuMatchLoadingList(prev => prev.filter(id => id !== recordRef.current.skuId)); continue; }
            file = resizeRes.file
            // 上传图片
            const legalRes = await Utils.checkImageIslegal(file, 0, UPLOAD_SOURCE.SERVICE)
            if (!legalRes || !legalRes.isLegal) { props.listSkuByProject(); setSkuMatchLoadingList(prev => prev.filter(id => id !== recordRef.current.skuId)); continue }
            if (type == 'matchImg') {
                const clothType = await API.getClothType({ imageUrl: legalRes?.data })
                const mainImgClothType = recordRef.current?.inputImages?.filter(item => item.mainImage)?.[0]?.clothType
                const clothTextList = ['上装', '下装', null, '裙装']
                if ((clothType?.data === 0 && mainImgClothType === 1) || (clothType?.data === 1 && mainImgClothType === 0)) {
                    saveUploadImg(type, legalRes)
                } else if (mainImgClothType === '') { // 主图还没检测出来时候
                    saveUploadImg(type, legalRes)
                } else {
                    PSAIModal.confirm({
                        title: `上传的搭配图是否为${clothTextList[clothType.data]}？`,
                        content: `系统检测到您上传的图片可能是${clothTextList[mainImgClothType]}，若填入，可能会影响生成效果`,
                        okText: "继续填入",
                        cancelText: `取消上传`,
                        onOk() {
                            saveUploadImg(type, legalRes)
                        },
                        onCancel() {
                            setSkuMatchLoadingList(prev => prev.filter(id => id !== recordRef.current.skuId));
                        }
                    })
                }
            } else {
                const skuName = removeExtension(file.name)
                saveUploadImg(type, legalRes, skuName)
            }
        }
        setLoading(false)
    }, 100), [])

    // 修改堆叠主品图数量
    const handleNumberChange = (type, record, value) => {
        const currentNum = record.inputImages?.[0]?.num || 1;

        if (type === 'minus' && currentNum <= 1) return;
        if (type === 'add' && currentNum >= 50) return;

        let newNum;
        switch (type) {
            case 'minus':
                newNum = currentNum - 1;
                break;
            case 'add':
                newNum = currentNum + 1;
                break;
            case 'change':
                newNum = value;
                break;
            default:
                return;
        }

        setDataSource(prev =>
            prev.map(item =>
                item.skuId === record.skuId
                    ? {
                        ...item,
                        inputImages: item.inputImages?.map((img, index) =>
                            index === 0
                                ? { ...img, num: newNum }
                                : img
                        ) || [{ num: newNum }]
                    }
                    : item
            )
        );
    }

    const saveUploadImg = async (type, legalRes, skuName = null) => {
        // 根据 type 和 inputImages 中是否已存在相应的 mainImage 项来决定是替换还是新增
        let updatedInputImages = [...recordRef.current.inputImages];
        const isMatchImg = type === 'matchImg';
        const targetMainImageValue = isMatchImg ? false : true;

        // 查找是否已存在相应的 mainImage 项
        const existingIndex = updatedInputImages.findIndex(item => item.mainImage === targetMainImageValue);

        if (existingIndex !== -1) {
            // 如果存在，则替换该项
            updatedInputImages[existingIndex] = {
                mainImage: targetMainImageValue,
                url: legalRes.data
            };
        } else {
            // 如果不存在，则新增项
            updatedInputImages.push({
                mainImage: targetMainImageValue,
                url: legalRes.data
            });
        }

        // 构造新的数据对象
        const updatedRecord = skuName
            ? {
                ...recordRef.current,
                skuName,
                inputImages: updatedInputImages,
                projectId
            }
            : {
                ...recordRef.current,
                inputImages: updatedInputImages,
                projectId
            };

        // 更新 dataSource 中对应项
        setDataSource(prev =>
            prev.map(item =>
                item.skuId === recordRef.current.skuId
                    ? { ...item, ...updatedRecord }
                    : item
            )
        );
        recordRef.current = { ...updatedRecord };
    };


    // 为上传搭配图加上loading
    const [skuMatchLoadingList, setSkuMatchLoadingList] = useState([])
    useEffect(() => {
        if (!dataSource || dataSource.length === 0) return;

        let newData = dataSource.map(item => ({
            ...item,
            matchLoading: skuMatchLoadingList.includes(item.skuId),
        }));

        // 检查上传完成的 sku
        const finishedIds = newData
            .filter(item => item.inputImages?.some(img => !img.mainImage))
            .map(item => item.skuId);

        if (finishedIds.length > 0) {
            setSkuMatchLoadingList(prev => prev.filter(id => !finishedIds.includes(id)));
        }

        const hasChange = newData.some(
            (item, idx) => item.matchLoading !== dataSource[idx]?.matchLoading
        );

        if (hasChange) {
            setDataSource(newData);
        }
    }, [skuMatchLoadingList]);



    const beforeUpload = async (file, fileList, record, type) => {
        if (type === 'matchImg') {
            setSkuMatchLoadingList(prev => {
                if (prev.includes(record.skuId)) return prev;
                return [...prev, record.skuId];
            });
        }

        recordRef.current = record
        uploadDebounce(file, fileList, type)
        return false
    }
    const handleDrop = async (e, type) => {
        e.stopPropagation()
        if ("getFilesAndDirectories" in e.dataTransfer) {
            const filesAndDirs = await e.dataTransfer.getFilesAndDirectories()
            const fileList = await Utils.getFilesFromDirs(filesAndDirs, "/")
            console.log('===handleDrop===')
            uploadDebounce(fileList[0], fileList, type)
            return false
        }
    }

    // 打开素材抽屉  selectedValue: 已选择的素材值, uploadCount: 上传数量, record: 当前记录, uploadType: 素材类型
    const openReferenceDrawer = (selectedValue, uploadCount, record, uploadType) => {
        setDrawSelectedValue([...selectedValue])
        setUploadCount(uploadCount)
        recordRef.current = record
        setUploadType(uploadType);
        setDrawOpen(true)
    }

    // 为recordRef.current更新为最新的项，避免旧的recordRef.current覆盖保存
    useEffect(() => {
        if (dataSource.length > 0) {
            const updatedRecord = dataSource.find(item => item.skuId === recordRef.current.skuId);
            if (updatedRecord) {
                recordRef.current = updatedRecord;
            }
        }
    }, [dataSource, recordRef.current])

    // 抽屉中确认选择模特、姿势、背景素材
    const handleReferenceChange = async (value) => {
        console.log(value);
        let updatedData = [];

        // 获取当前操作类型对应的字段
        const fieldMap = {
            changeModelBatch: "modelList",
            tryonBatch: "refList",
            changeBkgBatch: "bkgList",
            commodityStackingBatch: "refList",
        };
        const fieldKey = fieldMap[uploadType];
        if (!fieldKey) return;

        setDataSource(prev => {
            let newData = [...prev];

            if (Object.keys(recordRef.current).length === 0 && selectedRows.length > 0) {
                // 批量修改
                const selectedIds = new Set(selectedRows.map(item => item.skuId));

                newData = newData.map(item => {
                    if (selectedIds.has(item.skuId)) {
                        return { ...item, [fieldKey]: [...value] };
                    }
                    return item;
                });
            } else {
                // 单个修改
                const targetId = recordRef.current.skuId;
                newData = newData.map(item => {
                    if (item.skuId === targetId) {
                        return { ...item, [fieldKey]: [...value] };
                    }
                    return item;
                });
            }

            updatedData = newData;
            return newData;
        });

        recordRef.current = {};
        footerBarRef.current?.handleBatchExit();
    };


    // 选择素材抽屉
    useEffect(() => {
        materialRef.current?.refresh()
    }, [drawOpen])

    // 批量禁止选中
    const [batchMode, setBatchMode] = useState()
    const getBatchMode = (mode) => {
        setBatchMode(mode)
    }

    const goBack = () => {
        if (isEdit) {
            navigate(-1)
        }
        setFileList([])
        if (dataSource.length === 0) {
            API.batchRemoveProject({
                projectId,
            }).then(res => {
                if (res?.code == 0) {
                    if (isProCenter) navigate('/home/myProject/batchImages')
                    else navigate('/home/product/batchImages')
                } else throw new Error(res.message)
            })
        } else {
            if (isProCenter) navigate('/home/myProject/batchImages')
            else navigate('/home/product/batchImages')
        }
    }

    // 辅品排序
    const [data, setData] = useState([]);
    const [currentSkuID, setCurrentSkuID] = useState('');
    const editCommoditySort = (record) => {
        if (record?.refList?.length === 0) return
        setCurrentSkuID(record.skuId)
        setData(JSON.parse(JSON.stringify(record?.refList ?? [])));
        setCommoditySortOpen(true)
    }

    const handleSortOk = () => {
        setDataSource(prev => {
            return prev.map(item => {
                if (item.skuId === currentSkuID) {
                    return { ...item, refList: [...data] };
                }
                return item;
            });
        });
        setCommoditySortOpen(false);
    }

    const Text = useMemo(() => {
        return projectType == BATCH_IMAGES_TYPE.TRYON_BATCH ? 'AI试衣' :
            projectType == BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ? '换模特' :
                projectType == BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ? '换背景' :
                    projectType == BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH ? '商品智能堆叠' :
                        ''
    }, [projectType])


    return (
        <div className={styles.tableWrap}>
            <div className={styles.GoBack}>
                <GoBack onClick={() => goBack()} />
                <span className={styles.TaskId}>项目ID：{projectSerial}</span>
                <span className={styles.TaskTitle}>
                    {Text}-{projectName}
                    {!isEdit && <EditOutlined style={{ marginLeft: '8px' }} onClick={() => editProjectName()} />}
                </span>
            </div>
            <Table
                className='personalTable'
                rowKey="skuId"
                columns={skuColumns}
                dataSource={dataSource}
                tableLayout="auto"
                pagination={false}
                {...(showSelectionColumn && {
                    rowSelection: {
                        selectedRowKeys,
                        onChange: (selectedRowKeys, selectedRows) => {
                            setSelectedRowKeys(selectedRowKeys);
                            setSelectedRows(selectedRows);
                        },
                        getCheckboxProps: record => ({
                            disabled: (batchMode == 'appendTop' || batchMode == 'appendBottom') ?
                                record.inputImages?.filter(item => item.mainImage === true)?.[0]?.clothType !== (batchMode == 'appendTop' ? 1 : batchMode == 'appendBottom' ? 0 : null) : false
                        })
                    }
                })}
                scroll={{
                    x: 'max-content',
                    y: `calc(100vh - 320px)`,
                }}
            />

            <div className={styles.Footer}>
                <FooterBar
                    ref={footerBarRef}
                    dataSource={dataSource}
                    setDataSource={setDataSource}
                    isEdit={isEdit} // 是否编辑状态
                    projectId={projectId}
                    projectType={projectType}
                    handleRemove={handleRemove} // 批量删除
                    listSkuByProject={props.listSkuByProject} // 刷新列表
                    openReferenceDrawer={openReferenceDrawer} // 打开素材抽屉
                    getBatchMode={getBatchMode} // 获取内部批量设置类型
                    uploading={uploading}
                    selectedRowKeys={selectedRowKeys}
                    selectedRows={selectedRows}
                    setShowSelectionColumn={setShowSelectionColumn} // 禁选行
                    setSelectedRowKeys={setSelectedRowKeys}
                    setSelectedRows={setSelectedRows}
                    onAddMore={() => {
                        setUploadOpen(true)
                    }} // 继续添加源素材
                    total={total} // // 用户选完素材后生成图总数
                    skuNumber={dataSource.length} // 总商品数
                    editSkuId={editSkuId} // 重新编辑时skuID
                    editTaskId={editTaskId}  // 重新编辑时taskID
                />
            </div>
            <PSAIModal
                title="添加源素材"
                maxWidth={920}
                open={uploadOpen}
                footer={null}
                onCancel={() => setUploadOpen(false)}
            >
                <UploadBox
                    projectType={projectType}
                    setUploadOpen={setUploadOpen}
                    onUpload={props.handleAddMore}
                />
            </PSAIModal>
            <PSAIModal
                title="辅品数量编辑和排序"
                maxWidth={520}
                open={commoditySortOpen}
                onCancel={() => setCommoditySortOpen(false)}
                onOk={handleSortOk}
            >
                <DragAndSort data={data} setData={setData} />
            </PSAIModal>
            <Drawer
                closable={false}
                onClose={() => setDrawOpen(false)}
                open={drawOpen}
                width={uploadCount === 1 ? 1700 : 1900}
                destroyOnHidden={true}
            >
                <SelectTryonPose
                    ref={materialRef}
                    setDrawOpen={setDrawOpen}
                    drawOpen={drawOpen}
                    maxCount={uploadCount}
                    projectType={projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ? uploadType : projectType}
                    value={drawSelectedValue}
                    onChange={handleReferenceChange}
                    onClose={() => setDrawOpen(false)}
                />
            </Drawer>
            <PSAIModal
                title={editNameTitle}
                maxWidth={400}
                okText={'确定'}
                open={editNameVisible}
                maskClosable={false}
                okButtonProps={{ disabled: false, loading: false }}
                onCancel={() => setEditNameVisible(false)}
                onOk={() => updateNameOk()}
            >
                <div className={styles.editNameContent}>
                    <Input
                        value={nickName}
                        suffix={`${nickName.length}/40`}
                        onChange={(e) => setNickName(e.target.value.trim())}
                        maxLength={40}
                        placeholder='请输入新名称' />
                </div>
            </PSAIModal>
        </div>

    )
}

export default TableWrap